import { Plugins } from '@leverege/plugin';
import Constants from "../Constants.js";
import SourceValueRenderer from "./SourceValueRenderer.js";
/**
 * The ValueRendererFactory maps the geoLayer type to a plugin that contains a 
 * getLayers() call. The Plugin addition should look like: 
 * <pre>
 *   molten.addPlugin( 'Molten.GroupingValueLayer', { 
 *     type : <valueLayerType>, getLayers : function( {
 *        groupings,  // The groupings object
 *        section,    // The section in the groupings
 *        value,      // The value data in the section that is being renderered
 *        layer,      // The layer in the geoLayers of the value
 *        index,      // The index of the layer in the geoLayer of the value
 *        opacity,    // The opacity to use
 *        model,      // The GroupingsModel for the renderer
 *        selected,   // If true, this value is the section's selected value
 *        baseId,     // Base key for this value
 *        before      // The before parameter for the layers
 *      } )
 * </pre>
 * 
 * The value objectss will be rendered regardless if they are selected to allow them
 * to fade out. Use selected to render/not render.
 */
const ValueRendererFactory = Plugins.createFactory(Constants.VALUE_LAYER_PLUGIN_TYPE, {
  pluginKey: 'getLayers',
  strategy: Plugins.LOOKUP,
  defaultObject: SourceValueRenderer
});
export default ValueRendererFactory;